import axios from "axios";

export default {
  async getHostConfiguration() {
    return axios.get("/api/host");
  },
};
